export const NOVEL_IMPORT_MAX_FILE_BYTES = 15 * 1024 * 1024
export const NOVEL_IMPORT_MAX_RUNES = 5_000_000
export const NOVEL_IMPORT_WARNING_RUNES = 4_500_000

export function stripBOM(s: string) {
  return s.charCodeAt(0) === 0xfeff ? s.slice(1) : s
}

// 严格 UTF-8 成功即信 (标准, 不反转); 仅当严格解码抛错时回退 gb18030。
// 理由 (review: 防把合法俄语/希腊语 UTF-8 误判成 GBK): 真实中文 GBK 长文几乎必含
// 非法 UTF-8 字节序列 (GBK 尾字节 0x40-0xFE 多数非 UTF-8 续字节 0x80-0xBF) → 严格解码
// 必抛错 → 正确回退。只有短到"整篇恰好都是合法 UTF-8"的 GBK 才漏判, 而小说导入永远是
// 长文, 该情况实际不存在。反转启发式无法区分 '小说'(GBK) 与 'С˵'(合法西里尔 UTF-8) ——
// 二者字节完全相同 —— 故移除, 以免损坏合法非中文 UTF-8。
export function decodeNovelFile(buf: ArrayBuffer): { text: string; encoding: string } {
  try {
    return { text: stripBOM(new TextDecoder('utf-8', { fatal: true }).decode(buf)), encoding: 'utf-8' }
  } catch {
    const legacy = decodeLegacyChinese(buf)
    if (legacy !== null) {
      return { text: stripBOM(legacy), encoding: 'gb18030' }
    }
    return { text: stripBOM(new TextDecoder('utf-8').decode(buf)), encoding: 'utf-8-lossy' }
  }
}

export function countNovelRunes(text: string) {
  return Array.from(text).length
}

function decodeLegacyChinese(buf: ArrayBuffer) {
  try {
    return new TextDecoder('gb18030').decode(buf)
  } catch {
    return null
  }
}
